import Proxy from './Proxy';

class ResolvedReportsProxy extends Proxy {
  /**
   * The constructor for the ReportsProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/Alerts', parameters);
  }

  /**
   * Method used to fetch Reports list.
   *
   * @param {Object} data data to fetch reports enrolled list
   *
   * @returns {Promise} The result in a promise.
   */
  fetchReportsResolved(data) {
    return this.submit('post', `${this.endpoint}/resolvedSymptomsReport`, data);
  }

  fetchSymptomsReports(data){
    return this.submit('post', `${this.endpoint}/symptomsReport`, data);
  }
  
}

export default ResolvedReportsProxy;
